import * as React from 'react';
import { WarningIcon } from '../svg/WarningIcon';
var ErrorMessage = function (props) { return (React.createElement("div", { className: "box-border flex max-w-104 items-center rounded-2xl border-3 border-solid border-tomato p-6 text-[22px] font-bold leading-7 mobile:text-base mobile:leading-6" },
    React.createElement(WarningIcon, { className: "pr-4" }),
    React.createElement("span", null, props.text))); };
export default ErrorMessage;
